/* Farmacias LF · Ficha de producto (sections/lf-main-product.liquid).
   - Galería: carrusel con scroll-snap, contador, puntos, miniaturas y zoom (panel de lf-capsula.js).
   - Cantidad: botones − / + sobre el input name="quantity" del formulario de product-form.js.
   - Variantes: el <select> actualiza el id del formulario, el precio, el precio por unidad y la disponibilidad
     con los datos de <script type="application/json" data-lf-variants>.
   - «¿Qué es?» del sello bioequivalente, compartir y desplazamiento suave (data-lf-scroll) a #como-comprar,
     al bloque «Cómo comprarlo» de los dispositivos de inserción y a las alternativas desde la ficha agotada.
   - Las recomendaciones de la ficha agotada las carga <product-recommendations> de global.js (sin JS propio).
   La barra fija inferior usa data-lf-sticky-watch (lf-capsula.js) más un respaldo por scroll (initBar). */
(() => {
  const initGallery = (pdp) => {
    const track = pdp.querySelector('[data-lf-track]');
    if (!track) return;
    const slides = Array.from(track.querySelectorAll('[data-lf-slide]'));
    const count = pdp.querySelector('[data-lf-count]');
    const dots = Array.from(pdp.querySelectorAll('[data-lf-dot]'));
    const thumbs = Array.from(pdp.querySelectorAll('[data-lf-thumb]'));
    const zoomBtn = pdp.querySelector('[data-lf-zoom]');
    let current = 0;

    const setCurrent = (i) => {
      current = i;
      if (count) count.textContent = `${i + 1} / ${slides.length}`;
      dots.forEach((d, k) => d.classList.toggle('lf-on', k === i));
      thumbs.forEach((t, k) => {
        t.classList.toggle('lf-on', k === i);
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    };

    let frame = 0;
    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const w = track.clientWidth || 1;
          const i = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / w)));
          if (i !== current) setCurrent(i);
        });
      },
      { passive: true }
    );

    thumbs.forEach((t, k) =>
      t.addEventListener('click', () => {
        track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' });
        setCurrent(k);
      })
    );

    track.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      const next = Math.min(slides.length - 1, Math.max(0, current + (e.key === 'ArrowRight' ? 1 : -1)));
      track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
      setCurrent(next);
    });

    if (!zoomBtn) return;
    // lf-capsula.js abre el panel (data-lf-open); aquí solo se lleva a la imagen que se estaba viendo.
    zoomBtn.addEventListener('click', () => {
      const panel = document.getElementById(zoomBtn.dataset.lfOpen);
      const items = panel ? panel.querySelectorAll('[data-lf-zoom-item]') : [];
      const target = items[current];
      if (panel && target) setTimeout(() => { panel.scrollTop = target.offsetTop - 64; }, 80);
    });
    // En escritorio, un clic en la foto abre el zoom (en el celular el gesto es deslizar).
    slides.forEach((s) =>
      s.addEventListener('click', () => {
        if (window.matchMedia('(min-width: 750px)').matches) zoomBtn.click();
      })
    );
  };

  const initQty = (pdp) => {
    pdp.querySelectorAll('[data-lf-qty]').forEach((wrap) => {
      const input = wrap.querySelector('input');
      if (!input) return;
      const clamp = (v) => {
        const min = parseInt(input.min, 10) || 1;
        const max = input.max ? parseInt(input.max, 10) : Infinity;
        return Math.max(min, Math.min(max, v));
      };
      wrap.querySelectorAll('[data-lf-step]').forEach((b) =>
        b.addEventListener('click', () => {
          const step = parseInt(b.dataset.lfStep, 10) || 0;
          input.value = clamp((parseInt(input.value, 10) || 1) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        })
      );
      input.addEventListener('change', () => {
        input.value = clamp(parseInt(input.value, 10) || 1);
      });
    });
  };

  const initVariants = (pdp) => {
    const select = pdp.querySelector('[data-lf-variant-select]');
    const dataEl = pdp.querySelector('[data-lf-variants]');
    if (!select || !dataEl) return;
    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    const form = select.closest('form');
    const idInput = form ? form.querySelector('[name="id"]') : null;

    select.addEventListener('change', () => {
      const v = variants.find((x) => String(x.id) === select.value);
      if (!v) return;
      if (idInput) idInput.value = v.id;
      pdp.querySelectorAll('[data-lf-price]').forEach((el) => { el.textContent = v.price; });
      pdp.querySelectorAll('[data-lf-unit]').forEach((el) => {
        el.textContent = v.unit || '';
        el.hidden = !v.unit;
      });
      const short = v.unit && v.unit.includes(' por ') ? `${v.unit.split(' por ')[0]} c/u` : v.unit || '';
      pdp.querySelectorAll('[data-lf-unit-short]').forEach((el) => {
        el.textContent = short;
        el.hidden = !short;
      });
      pdp.querySelectorAll('[data-lf-compare]').forEach((el) => {
        el.textContent = v.compare || '';
        el.hidden = !v.compare;
      });
      pdp.querySelectorAll('[data-lf-add]').forEach((btn) => {
        btn.disabled = !v.available;
        btn.removeAttribute('aria-disabled');
        const label = btn.querySelector('[data-lf-add-label]');
        if (label) label.textContent = v.available ? btn.dataset.lfLabel : btn.dataset.lfSoldout;
      });
      const errorWrap = pdp.querySelector('.product-form__error-message-wrapper');
      if (errorWrap) errorWrap.hidden = true;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* sin historial */ }
    });
  };

  const initToggles = (pdp) => {
    pdp.querySelectorAll('[data-lf-toggle]').forEach((btn) => {
      const target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        target.hidden = open;
      });
    });
  };

  const initShare = (pdp) => {
    const btn = pdp.querySelector('[data-lf-share]');
    if (!btn) return;
    const status = pdp.querySelector('[data-lf-share-status]');
    btn.addEventListener('click', async () => {
      const url = window.location.href.split('#')[0];
      const title = (pdp.querySelector('.lf-pdp__title') || {}).textContent || document.title;
      if (navigator.share) {
        try { await navigator.share({ title: title.trim(), url }); } catch (e) { /* cancelado */ }
        return;
      }
      try {
        await navigator.clipboard.writeText(url);
        if (status) status.textContent = 'Enlace copiado';
        btn.classList.add('lf-is-done');
        setTimeout(() => {
          btn.classList.remove('lf-is-done');
          if (status) status.textContent = '';
        }, 2200);
      } catch (e) { /* sin portapapeles */ }
    });
  };

  const initScroll = (pdp) => {
    pdp.querySelectorAll('[data-lf-scroll]').forEach((a) => {
      a.addEventListener('click', (e) => {
        const id = (a.getAttribute('href') || '').replace('#', '');
        const target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        target.focus({ preventScroll: true });
      });
    });
  };

  // Respaldo de la barra fija: el IntersectionObserver de lf-capsula.js solo avisa cuando el elemento
  // vigilado cruza la pantalla; si la página salta más allá sin mostrarlo (ancla «Comparar», scroll
  // restaurado), la barra no aparecería. Aquí se recalcula en cada scroll (una vez por cuadro).
  const initBar = (pdp) => {
    const bar = pdp.querySelector('.lf-pdp-bar[data-lf-sticky-watch]');
    if (!bar) return;
    document.body.classList.add('lf-has-pdp-bar');
    const target = document.querySelector(bar.dataset.lfStickyWatch);
    if (!target) return;
    let frame = 0;
    const update = () => {
      frame = 0;
      bar.classList.toggle('lf-is-visible', target.getBoundingClientRect().bottom < 0);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();
  };

  const init = (root) => {
    root.querySelectorAll('[data-lf-pdp]').forEach((pdp) => {
      if (pdp.dataset.lfReady) return;
      pdp.dataset.lfReady = '1';
      initGallery(pdp);
      initQty(pdp);
      initVariants(pdp);
      initToggles(pdp);
      initShare(pdp);
      initScroll(pdp);
      initBar(pdp);
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
